;(function () {
  angular
    .module('contrast.rules')
    .controller('ModalAssessRuleModalCtrl', ModalAssessRuleModalCtrl)

  function ModalAssessRuleModalCtrl(
    $scope,
    $uibModalInstance,
    $translate,
    logger,
    RulesService,
    appIds,
    ruleId,
    quickFilter,
    filterText,
    allRulesSelected
  ) {
    'ngInject'

    angular.extend($scope, {
      model: {
        dev_enabled: false,
        qa_enabled: false,
        prod_enabled: false
      }
    })

    angular.extend($scope, {
      update: update,
      cancel: cancel
    })

    function update() {
      return RulesService.updateStatusByRule(
        allRulesSelected ? [] : appIds,
        ruleId,
        filterText,
        quickFilter,
        $scope.model.dev_enabled,
        $scope.model.qa_enabled,
        $scope.model.prod_enabled
      )
        .then(function () {
          logger.logSuccess(
            $translate.instant('detail_assessRules_successfulPolicyUpdate')
          )
          $uibModalInstance.close()
        })
        .catch(function () {
          logger.logError(
            $translate.instant('detail_assessRules_policyUpdateError')
          )
        })
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel')
    }
  }
})()
